import Markdown from "markdown-to-jsx";
import './output.css';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function OutputPage({ messages, isMessageLoading, ref }) {
  return (
    <div
      style={{
        borderRadius: '10px',
        padding: "18px",
        width: '50vw',
        overflowY: 'auto',
        height: '50vh',
        scrollBehavior: 'smooth',
        scrollbarWidth: 'none',
        // backgroundImage: 'linear-gradient(to right, #0080FF, #00C0FF)',
        backgroundColor:'#000'
      }}
      className="outputWidth"
      ref={ref}
    >
       {isMessageLoading ? (
    <div className="skeletonWrapper" style={{zIndex:1}}>
        <Skeleton enableAnimation count={2} style={{
            marginBottom:'10px',
            backgroundColor:'#A9A9A9'
        }} />
        <Skeleton enableAnimation count={1} style={{
            marginBottom:'10px',
            backgroundColor:'#A9A9A9',
            width:'80%'
        }} />
        <Skeleton enableAnimation count={1} style={{
            marginBottom:'10px',
            backgroundColor:'#A9A9A9',
            width:'60%'
        }} />
        <Skeleton enableAnimation count={1} style={{
            marginBottom:'10px',
            backgroundColor:'#A9A9A9',
            width:'50%'
        }} />
    </div>
) : (
    <Markdown
        options={{
            overrides: {
                p: {
                    props: {
                        style: {
                            margin: '1em 0',
                        },
                    },
                },
            },
        }}
        style={{
            color: '#fff',
            fontSize: '15px',
            fontFamily: 'Poppins',
            marginLeft: '10px',
        }}
    >
        {messages}
    </Markdown>
)}
    </div>
  );
}
